import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraLink, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraEntityCell, SpecraKeyValueRow, SpecraRestrictedChip, SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
export const VAULT_REASON = 'Person-level rates are only visible to the small vault group, and every read is logged.';
export function PeopleWeKnow({ people, companyName }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "People we know there"
            }),
            !people.length && /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                size: "body-ui",
                tone: "muted",
                children: [
                    "No people recorded at ",
                    companyName,
                    " yet."
                ]
            }),
            people.map((p)=>{
                const former = [
                    ...p.employments
                ].reverse().find((e)=>e.employer?.kind === 'GOVERNMENT_ORG' && !e.isHere);
                return /*#__PURE__*/ _jsx(SpecraKeyValueRow, {
                    "data-testid": Testids.registryCompany.personRow,
                    label: /*#__PURE__*/ _jsx(SpecraEntityCell, {
                        title: /*#__PURE__*/ _jsxs(SpecraLink, {
                            href: `/registries/contacts/${encodeURIComponent(p.contactId)}`,
                            renderLink: renderRouterLink,
                            children: [
                                p.name,
                                p.titleHere && ` · ${p.titleHere}`
                            ]
                        }),
                        description: p.moveNote || `${p.visibleTouchpointCount} touchpoints${p.source?.text ? ` · ${p.source.text}` : ''}${p.hereStatus === 'PAST' ? ' · Previously here' : ''}`
                    }),
                    value: /*#__PURE__*/ _jsxs("div", {
                        className: "space-y-1",
                        children: [
                            former && /*#__PURE__*/ _jsxs(SpecraText, {
                                as: "p",
                                size: "meta",
                                tone: "muted",
                                children: [
                                    "Former ",
                                    former.employer?.name || former.employerText
                                ]
                            }),
                            /*#__PURE__*/ _jsx(SpecraRestrictedChip, {
                                "data-testid": Testids.registryCompany.restrictedChip,
                                label: "Rate trail restricted",
                                reason: VAULT_REASON
                            })
                        ]
                    })
                }, p.contactId);
            }),
            /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "body-ui",
                tone: "muted",
                children: VAULT_REASON
            })
        ]
    });
}
